import store from "datastore/store";

import { convertFromSecToJs } from "common/date";
import Api from "util/api";

async function getAllStripeSubcriptions() {
  let result;
  try {
    result = await Api.post("/getAllStripeSubscriptions");
  } catch (error) {
    store.dispatch({ type: "ADD_ALL_STRIPE_SUBSCRIPTIONS_ERROR" });
  }
  const resultJson = await result.json();
  if (result.ok && resultJson.status === "success") {
    const resultArr = resultJson.data;
    const subscriptions = resultArr.map((el) => ({
      ...el,
      period_end: convertFromSecToJs(
        el.object === "subscription_schedule"
          ? el.phases[0].start_date
          : el.current_period_end
      ),
    }));
    return subscriptions;
  } else {
    console.log(resultJson.error);
    return [];
  }
}

export default async function fetchAllStripeSubscriptions() {
  store.dispatch({ type: "ADD_ALL_STRIPE_SUBSCRIPTIONS_LOADING" });
  const data = await getAllStripeSubcriptions();
  store.dispatch({ type: "ADD_ALL_STRIPE_SUBSCRIPTIONS_SUCCESS", data });
}
